export default "__VITE_ASSET__CClo8fuB__"